<template>
  <div :class="['header', { collapsed: !isSidebarOpen }]">
    <div class="header-title">
      <h3>Digital Credit Transfer</h3>
      <h6>Backend Environment</h6>
    </div>

    <div class="header-role">
      <span>Current Role</span>
      <span class="role-badge">Admin</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HeaderPanel',
    props: {
    isSidebarOpen: {
      type: Boolean,
      default: true
    }
  }
  }
</script>

<style scoped>
/*  header container  */

.header {
  width: 100%;
  height: 10vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 5rem 1rem 19%;
  background-color: #fff;
  color: #4a5565;
  border-bottom: 1px solid #0000001a;
  transition: all 0.3s ease;
}

.header.collapsed {
  padding-left: 5rem;
}

/*  title  */

.header-title h3 {
  color: #101828;
}

.header-title h6 {
  color: #4a5565;
}

/*  role  */

.header-role span {
  margin: 0 0.25rem;
}

.role-badge {
  border: 1px solid #ffc9c9;
  background-color: #ffe2e2;
  border-radius: calc(0.625rem - 2px);
  padding: 0.5rem 1rem;
  color: #9f0712;
  font-weight: bold;
}

</style>